<template>
	<div id="app">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><a href="/">管理员管理</a></el-breadcrumb-item>
			<el-breadcrumb-item>管理员列表</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 卡片视图区域 -->
		<el-card>


			<el-table :data="userList" border stripe>
				<el-table-column type="index" label="#"></el-table-column>
				<el-table-column prop="username" label="管理员名"></el-table-column>
				<el-table-column prop="password" label="密码"></el-table-column>
				<!-- <el-table-column prop="password" label="状态">
					<el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">
					</el-switch>
				</el-table-column> -->
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<div v-if="scope.row.status==0" class="show1">普通用户</div>
						<div v-if="scope.row.status==1" class="show2">家教老师</div>
					</template>
				</el-table-column>

				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" size="mini" @click="edit(scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" size="mini"
							@click="del(scope.row.id)"></el-button>
						<!-- <el-button type="warning" icon="el-icon-setting" size="mini"></el-button> -->
					</template>
				</el-table-column>

			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[2, 4, 6, 8]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</el-card>

		<!-- 修改管理员得对话框 -->
		<el-dialog title="修改管理员" :visible.sync="editDialog" width="40%">
			<span>
				<el-form ref="editFormRef" :model="editForm" label-width="70px">
					<!-- <el-form-item label="普通用户">
						<el-input v-model="editForm.username"></el-input>
					</el-form-item>
					<el-form-item label="家教老师">
						<el-input v-model="editForm.password"></el-input>
					</el-form-item> -->
					<el-radio v-model="radio" label="0">普通用户</el-radio>
					<el-radio v-model="radio" label="1">家教老师</el-radio>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editDialog = false">取 消</el-button>
				<el-button type="primary" @click="editUser">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		HomeUserlist,
		UpdataHomeUser,
		HomeUserdel
	} from '@/api/index.js'
	export default {
		data() {
			return {
				userList: [],
				selectUserObj: {},
				pageNum: 1,
				pageSize: 6,
				addForm: {
					username: "",
					password: "",
				},
				editForm: {

				},
				addDialog: false,
				editDialog: false,
				total: 0,
				value: true,
				radio: "1"
			}
		},
		created() {
			this.getUsersList();
		},
		methods: {
			async getUsersList() {
				const {
					data: res
				} = await HomeUserlist({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});
				console.log(res);
				this.userList = res.data.list;
				this.total = res.data.total;

				// console.log(this.userList);
			},
			handleSizeChange(newsize) {
				this.pageSize = newsize;
				this.getUsersList();
			},
			handleCurrentChange(newnum) {
				this.pageNum = newnum;
				this.getUsersList();
			},
			edit(row) {
				this.editDialog = true;
				console.log(row);
				this.editForm.id = row.id,
					// this.editForm.status = row.status,
					this.radio = row.status

			},
			async editUser() {
				console.log(this.editForm.id);
				const {
					data: res
				} = await UpdataHomeUser({
					id: this.editForm.id,
					status: this.radio,
				})

				this.editDialog = false;
				if (res.code == 200) {
					this.$message.success('修改成功')
				} else {
					this.$message.error('修改失败')
				}
				this.getUsersList();
			},
			async del(id) {
				const {
					data: res
				} = await HomeUserdel({
					id: id
				})
				if (res.code == 200) {
					this.$message.success('删除成功')
				} else {
					this.$message.error('删除失败')
				}
				this.getUsersList();
			},
		}
	}
</script>
<style scoped>
	.el-card {
		margin-top: 20px;
	}

	.el-row {
		margin-bottom: 20px;
	}

	/* 	.show1 {
		width: 60px;
		text-align: center;
		border-radius: 5px;
		background: #F39141;
		color: #fff;
	}
	
	.show2 {
		width: 60px;
		text-align: center;
		border-radius: 5px;
		background: #F39141;
		color: #fff;
	} */
</style>